import { Box, Stack } from '@mui/material'
import { memo, useEffect, useRef, useState } from 'react'

import SubmitButton from 'src/components/shared/button/SubmitButton'
import CustomLinearProgress from 'src/components/shared/progressBar/CustomLinearProgress'
import Text from 'src/components/shared/text/Text'
import { nextTargetTimeStartTime } from 'src/util/date.helpers'

const StakeUnlockTimer = ({
  t,
  stakedQBX,
  startTime,
  endTime,
  onStakedClaim
}) => {
  const unlockTimer = useRef(null)

  const [timer, setTimer] = useState(
    nextTargetTimeStartTime({ startTime, endTime })
  )

  const updateTimer = () => {
    setTimer(nextTargetTimeStartTime({ startTime, endTime }))
  }

  useEffect(() => {
    unlockTimer.current = setInterval(updateTimer, 1000)
    return () => {
      clearUnlockInterval()
    }
  }, [startTime, endTime])

  useEffect(() => {
    if (!timer.active) {
      clearUnlockInterval()
    }
  }, [timer.active])

  const clearUnlockInterval = () => {
    clearInterval(unlockTimer.current)
  }

  return (
    <Box
      sx={{
        gap: 2,
        bgcolor: 'background.neutral',
        borderRadius: 1.5,
        p: 2,
        display: 'flex'
      }}
    >
      <Stack spacing={1} width='100%' flex={1}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          sx={{ justifyContent: 'space-between' }}
        >
          <Text
            variant='body2'
            label={t('brand:staking.staked-unlock-in')}
            fontWeight={600}
          />
          <Text variant='body2' label={timer.timeLeft} fontWeight={600} />
        </Stack>
        <CustomLinearProgress
          completed={stakedQBX > 0 ? timer.progress : 0}
          height={8}
        />
      </Stack>
      <SubmitButton
        label={t('brand:staking.unstake')}
        type='button'
        onClick={onStakedClaim}
        disabled={!(stakedQBX > 0 && timer.progress >= 100)}
      />
    </Box>
  )
}

export default memo(StakeUnlockTimer)
